// 현장 기록 액션(rpc, legacy modules/project/log-actions) — 사진 삭제·공정 상태·공정 사유 · 일지 쓰기·지우기·댓글 · 사진 올리기.
import { rpc } from "@/api/client";

export const deleteProjectPhoto = (projectId: string, photoId: string) => rpc("project/log-actions/deleteProjectPhoto", projectId, photoId);

export const setProjectPhaseStatus = (projectId: string, input: unknown) => rpc("project/log-actions/setProjectPhaseStatus", projectId, input);

export const setProjectPhaseReason = (projectId: string, input: unknown) => rpc("project/log-actions/setProjectPhaseReason", projectId, input);

export const addProjectLog = (projectId: string, input: unknown) => rpc("project/log-actions/addProjectLog", projectId, input);

export const addProjectLogComment = (projectId: string, input: { log_id: string; body: string }) =>
  rpc("project/log-actions/addProjectLogComment", projectId, input);

export const deleteProjectLog = (projectId: string, logId: string) => rpc("project/log-actions/deleteProjectLog", projectId, logId);

// 사진 바이트는 multipart 로 — FormData 자리는 client 가 표지({"$form":true})로 바꿔 보낸다.
export const uploadProjectPhoto = (projectId: string, form: FormData) => rpc("project/log-actions/uploadProjectPhoto", projectId, form);
